import { swSettings } from "app/common/services/swSettings";
import {
    isNoTouch,
    isSI,
    isTraditionalTrialOrAfterTrialUser,
} from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

export const shouldShowHDBanner = (): boolean =>
    isNoTouch(swSettings) && !isTraditionalTrialOrAfterTrialUser(swSettings) && !isSI(swSettings);
